<template>
  <div class="offer d-flex">
    <div v-if="isUsWarehouse">
      <img :src="$root.cdn_url + '/assets/images/zmc10/free-shipping-us.png'" style="width:99px" class="mr-3" />
    </div>
    <div :class="{ 'text-center': !isUsWarehouse }" class="flex-grow-1">
      <p>
        <span class="bold">{{ speсialOffer }}: </span> {{ product.long_name }}
      </p>
      <p>
        {{ price }}:&nbsp;

        <span id="old-price" class="price-object productprice-old-object strike">
          {{ product.prices["1"]["old_value_text"] }}
        </span>
        <span class="price-span">
          <b
            ><span id="new-price" class="price-object productprice-object">
              {{ product.prices["1"]["value_text"] }}
            </span></b
          > </span
        >&nbsp; ({{ product.prices["1"].discount_percent }}% {{ discount }})
      </p>
      <p v-if="isUsWarehouse" v-html="textFreeDeliveryUs" class="us-note"></p>
    </div>
  </div>
</template>

<script>
import { t } from "../../utils/i18n";
import { isUsWarehouse } from "../../utils/checkout";

export default {
  name: "ProductOffer",
  computed: {
    product() {
      return js_data.product;
    },
    speсialOffer: () => t("checkout.header_banner.prefix"),
    price: () => t("checkout.header_banner.price"),
    discount: () => t("checkout.header_banner.discount"),
    textFreeDeliveryUs: () => t("checkout.free_delivery_us"),
    isUsWarehouse: () => isUsWarehouse(),
  }
};
</script>

<style lang="scss">
.us-note span {
  color: #16a085;
}
</style>
